const bidderHandlers = require('./bidders/index'),
	NO_BIDDERS = [];

function getBidders(config, slot) {
	const slotInfo = config.slots[slot.name];

	if (typeof slotInfo === 'undefined' || typeof slotInfo.bidders === 'undefined') {
		return NO_BIDDERS;
	}

	return _getBiddersForCurrentBreakpoint(slotInfo)
		.map((bidder) => _getBidder(config, slot, bidder))
		.filter(b => b !== null);
}

function _getBiddersForCurrentBreakpoint(slotInfo) {
	if (Array.isArray(slotInfo.bidders)) {
		return slotInfo.bidders;
	}

	const currentBp = window.advert.getCurrentBreakpoint();

	if (Array.isArray(slotInfo.bidders[currentBp])) {
		return slotInfo.bidders[currentBp];
	}

	if (Array.isArray(slotInfo.bidders.default)) {
		return slotInfo.bidders.default;
	}

	return NO_BIDDERS;
}

function _getBidder(config, slot, slotBidderCfg) {
	if (typeof bidderHandlers[slotBidderCfg.bidder] !== 'undefined') {
		return _getFromBidderHandler(config, slot, slotBidderCfg);
	}

	return bidderHandlers.default(config, slotBidderCfg);
}

function _getFromBidderHandler(config, slot, slotBidderCfg) {
	try {
		return bidderHandlers[slotBidderCfg.bidder](config, slot, slotBidderCfg);
	} catch (e) {
		console.error(`[ADVERT] Something went wrong processing the bidder handler for ${slotBidderCfg.name}`, e);

		return null;
	}
}

module.exports = {
	getBidders
};
